import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * 管理者ページ共通パンくずリスト
 *
 * Usage:
 * <AdminBreadcrumb items={[{ label: "ユーザ管理" }]} />
 * <AdminBreadcrumb items={[{ label: "ユーザ管理", path: "/admin/users-management" }, { label: "投稿ログ" }]} />
 */
export default function AdminBreadcrumb({ items = [] }) {
  const navigate = useNavigate();

  return (
    <nav
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "#888",
        marginBottom: "1.25rem",
        flexWrap: "wrap",
      }}
      aria-label="パンくずリスト"
    >
      {/* 管理者メニュー（常にトップ） */}
      <span
        onClick={() => navigate("/admin")}
        style={{ color: "#185fa5", cursor: "pointer" }}
        onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
        onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
      >
        管理者メニュー
      </span>

      {items.map((item, i) => (
        <React.Fragment key={i}>
          <span style={{ color: "#ccc", fontSize: 10 }}>›</span>
          {item.path ? (
            <span
              onClick={() => navigate(item.path)}
              style={{ color: "#185fa5", cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
              onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
            >
              {item.label}
            </span>
          ) : (
            <span style={{ color: "#444", fontWeight: 500 }}>{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
